import { CombatPanel } from '../combat/CombatPanel';

/** React owns every combat command and information panel; Phaser stays visual-only. */
export function CombatLayout() {
  return (
    <div className="combat-layout ui-overlay">
      <CombatPanel />
    </div>
  );
}
